import { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import EvidenceSection from './components/EvidenceSection';
import TrustSection from './components/TrustSection';
import BenefitsCtaSection from './components/BenefitsCtaSection';
import ClosingSection from './components/ClosingSection';
import Footer from './components/Footer';
import BookingModal from './components/BookingModal';
import DealerModal from './components/DealerModal';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schemaWebSite = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'フィジオショット',
  url: siteUrl,
  description: 'フィジオショットは医師監修・韓国特許取得の最先端筋肉回復施術。独自のGAMMA輻射技術で筋肉の違和感・疲労を大幅に短縮。',
  inLanguage: 'ja',
};

const schemaOrganization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'フィジオショット',
  url: siteUrl,
  description: '医師監修・韓国特許取得の筋肉回復施術「フィジオショット」を全国34施設に導入。プロアスリートも採用するGAMMA輻射技術を活用したスポーツ施術ブランド。',
  areaServed: {
    '@type': 'Country',
    name: '日本',
  },
};

const schemaService = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'フィジオショット 筋肉回復施術',
  url: siteUrl,
  provider: {
    '@type': 'Organization',
    name: 'フィジオショット',
  },
  description: '独自のGAMMA輻射技術による医師監修・韓国特許取得の筋肉回復施術。プロアスリートも採用し、筋肉の違和感・疲労回復を大幅に短縮。全国34施設で導入済み。',
  serviceType: '筋肉回復施術',
  areaServed: {
    '@type': 'Country',
    name: '日本',
  },
  audience: {
    '@type': 'Audience',
    audienceType: 'スポーツ選手・アスリート・筋肉疲労に悩む方',
  },
  offers: {
    '@type': 'Offer',
    availability: 'https://schema.org/InStore',
    areaServed: {
      '@type': 'Country',
      name: '日本',
    },
  },
};

export default function Home() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [dealerOpen, setDealerOpen] = useState(false);

  return (
    <div className="bg-[#0D0D0D] min-h-screen" style={{ fontFamily: '\'Noto Serif JP\', \'Noto Sans JP\', serif' }}>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaWebSite) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaOrganization) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaService) }}
      />
      <Navbar
        onOpenBooking={() => setBookingOpen(true)}
        onOpenDealer={() => setDealerOpen(true)}
      />
      <HeroSection
        onOpenBooking={() => setBookingOpen(true)}
        onOpenDealer={() => setDealerOpen(true)}
      />
      <ProblemSection />
      <SolutionSection />
      <EvidenceSection />
      <TrustSection />
      <BenefitsCtaSection
        onOpenBooking={() => setBookingOpen(true)}
        onOpenDealer={() => setDealerOpen(true)}
      />
      <ClosingSection
        onOpenBooking={() => setBookingOpen(true)}
        onOpenDealer={() => setDealerOpen(true)}
      />
      <Footer />

      <BookingModal isOpen={bookingOpen} onClose={() => setBookingOpen(false)} />
      <DealerModal isOpen={dealerOpen} onClose={() => setDealerOpen(false)} />
    </div>
  );
}
